var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["ACTIVITY_METRIC"] = "activity-metric";
  ServiceType2["ALCHEMY_BRIDGE"] = "alchemy-bridge";
  ServiceType2["API_KEYS"] = "api-keys";
  ServiceType2["AUDITING"] = "auditing";
  ServiceType2["AUTHORIZER"] = "authorizer";
  ServiceType2["BACKOFFICE_IAM"] = "backoffice-iam";
  ServiceType2["BULK"] = "bulk";
  ServiceType2["CERTIFICATE_REQUEST_MANAGER"] = "certs-req";
  ServiceType2["CERTS_INDEX"] = "certs-index";
  ServiceType2["CHANGE_REQUESTS"] = "change-requests";
  ServiceType2["COMPANIES"] = "companies";
  ServiceType2["CONNECTORS"] = "connectors";
  ServiceType2["CREDITS"] = "credits";
  ServiceType2["CUSTODIAN"] = "custodian";
  ServiceType2["CUSTOM_DOMAINS"] = "custom-domains";
  ServiceType2["EXTERNAL_CREDENTIAL"] = "external-credential";
  ServiceType2["IMAGE_GENERATOR"] = "images";
  ServiceType2["IMAGE_STORE"] = "image-store";
  ServiceType2["KYC"] = "kyc";
  ServiceType2["LEARNING_ROUTES"] = "learning-routes";
  ServiceType2["LINKEDIN_USERS"] = "linkedin-users";
  ServiceType2["LTI"] = "lti";
  ServiceType2["MARKETING"] = "marketing";
  ServiceType2["MINTER"] = "minter";
  ServiceType2["NOTIFIER"] = "notifier";
  ServiceType2["PAGES"] = "pages";
  ServiceType2["PREMIUM_FEATURES_MANAGER"] = "premium-features-manager";
  ServiceType2["PROOFS_PROXIES"] = "proxy";
  ServiceType2["RBAC"] = "rbac";
  ServiceType2["REGION_DETECTOR"] = "region-detector";
  ServiceType2["REPORTING"] = "reporting";
  ServiceType2["SANA"] = "sana";
  ServiceType2["SKILL_GRAPH"] = "skill-graph";
  ServiceType2["SOCIAL_MEDIA_BRIDGE_API"] = "share";
  ServiceType2["SOCIAL_MEDIA_BRIDGE_LINKEDIN"] = "linkedin";
  ServiceType2["TEMPLATE_MANAGER"] = "templates";
  ServiceType2["TRANSLATION_BRIDGE"] = "translation-bridge";
  ServiceType2["WEBHOOKS"] = "webhooks";
  return ServiceType2;
})(ServiceType || {});
var PublicService = /* @__PURE__ */ ((PublicService2) => {
  PublicService2["ALCHEMY_BRIDGE"] = "alchemy-bridge";
  PublicService2["API"] = "api";
  PublicService2["API_KEYS"] = "api-keys";
  PublicService2["BACKOFFICE"] = "backoffice";
  PublicService2["BACKOFFICE_API"] = "b";
  PublicService2["CERTIFIER"] = "mint";
  PublicService2["CERTIFIER_API"] = "c";
  PublicService2["COMPANIES"] = "companies";
  PublicService2["COMPANIES_API"] = "co";
  PublicService2["CREDENTIAL_LOOKUP"] = "lookup";
  PublicService2["CREDENTIAL_LOOKUP_API"] = "l";
  PublicService2["CREDITS"] = "credits";
  PublicService2["DOCS"] = "docs";
  PublicService2["HOLDER"] = "holder";
  PublicService2["HOLDER_API"] = "h";
  PublicService2["IMAGE_STORE"] = "image-store";
  PublicService2["KYC"] = "kyc";
  PublicService2["LTI"] = "lti";
  PublicService2["LTI_FRONTEND"] = "lti-frontend";
  PublicService2["MARKETING"] = "marketing";
  PublicService2["MINTER"] = "minter";
  PublicService2["RBAC"] = "rbac";
  PublicService2["SOCIAL_MEDIA_BRIDGE"] = "share";
  PublicService2["TEMPLATE_MANAGER"] = "templates";
  PublicService2["VC_RESOLVER"] = "vc";
  PublicService2["VIEWER"] = "view";
  PublicService2["VIEWER_API"] = "v";
  PublicService2["WEBHOOKS"] = "webhooks";
  return PublicService2;
})(PublicService || {});
const serviceEndpoints = (domain, overrides) => ({
  privateUrl: (service) => overrides?.private?.[service] ?? `https://${service}.private.${domain}`,
  publicUrl: (service) => overrides?.public?.[service] ?? `https://${service}.${domain}`
});
const REVOCATION_LIST_PATH_PREFIX = "/revocation";
const revocationListUrlFor = (viewerApiPublicRoot, organizationId) => `${viewerApiPublicRoot}${REVOCATION_LIST_PATH_PREFIX}/${organizationId}`;
const revocationListUrl = (endpoints, organizationId) => revocationListUrlFor(endpoints.publicUrl("v" /* VIEWER_API */), organizationId);
const serviceEndpointsFromEnv = (env) => serviceEndpoints(
  env.VITE_DOMAIN,
  env.VITE_ENDPOINT_OVERRIDES ? JSON.parse(env.VITE_ENDPOINT_OVERRIDES) : void 0
);
export {
  PublicService,
  REVOCATION_LIST_PATH_PREFIX,
  ServiceType,
  revocationListUrl,
  revocationListUrlFor,
  serviceEndpoints,
  serviceEndpointsFromEnv
};
//# sourceMappingURL=index.js.map
